// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reconciliation-file-table[data-v-722b7ca4] {\n  font-size: 0.85rem;\n}\n.reconciliation-file-table .raw-line[data-v-722b7ca4] {\n  font-family: monospace;\n  white-space: pre;\n}", ""]);
// Exports
module.exports = exports;
